/* oxlint-disable quantic/no-type-exports */

export enum TuitionBenefitAdministrators {
    GuildDirectPayNetwork = 'guild_direct_pay_network',
}
